var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpInfo",on:{"click":_vm.infoSave}},[_c('b-icon',{staticClass:"pointer",attrs:{"icon":"warning"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.textBtn))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }